class PdpSlideshow extends HTMLElement {
  constructor() {
    super();
    this.slideshow = this.querySelector(".swiper");
    this.pauseBtn = this.querySelector("[data-pause]");

    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;
      this.initFunction();
    });
  }

  initFunction() {
    if (!this.slideshow) return;

    const { Swiper, Pagination, EffectFade } = this.swiperLib;

    this.swiper = new Swiper(this.slideshow, {
      modules: [Pagination, EffectFade],
      // Default parameters
      slidesPerView: 1,
      spaceBetween: 0,
      direction: "horizontal",
      loop: true,
      effect: "fade",
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    this.pauseBtn.addEventListener("click", () => {
      if (this.swiper.autoplay.running) {
        this.swiper.autoplay.stop();
        this.pauseBtn.classList.add("paused");
      } else {
        this.swiper.autoplay.start();
        this.pauseBtn.classList.remove("paused");
      }
    });
  }
}

if (!customElements.get("pdp-slideshow")) {
  customElements.define("pdp-slideshow", PdpSlideshow);
}
